import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { http, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      {sent ? (
        <div className="text-center" data-testid="forgot-sent-panel">
          <MailCheck className="w-14 h-14 text-emerald-500 mx-auto" />
          <h2 className="font-display text-2xl font-bold text-[#0B132B] mt-5">Check your inbox</h2>
          <p className="text-slate-500 text-sm mt-2">If an account exists for <span className="font-medium">{email}</span>, we've sent a password reset link.</p>
          <Link to="/login"><Button className="mt-6 bg-[#0B132B] hover:bg-[#1C2541] h-11 px-8" data-testid="back-to-login-button">Back to sign in</Button></Link>
        </div>
      ) : (
        <>
          <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0B132B] mb-6" data-testid="back-link">
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-[#0B132B]">Forgot password?</h2>
          <p className="text-slate-500 text-sm mt-1.5 mb-6">Enter your email and we'll send you a reset link.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email address</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.co.za" className="mt-1.5 h-11" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full bg-[#0B132B] hover:bg-[#1C2541] h-11 font-semibold">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
            </Button>
          </form>
        </>
      )}
    </AuthShell>
  );
}
